export const UPDATE_TOKEN = 'UPDATE_TOKEN'

export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'

/**
 * 当前用户的权限列表
 */
export const UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS'

/**
 * 年度、期次下拉
 */
export const UPDATE_YEAR_PERIOD = 'update_year_period'

/**
 * 任务类型、业务类型下拉列表
 */
export const UPDATE_BUSINESSTYPE = 'update_business_type'

/**
 * 暗检创建任务时的有效日期下拉
 */
export const UPDATE_VALID_MONTHS = 'update_valid_months'
